import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import snackbar from './modules/snackbar'
import app from './modules/app'
import notifications from './modules/notifications'
import search from './modules/search'
import messages from './modules/messages'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        auth,
        snackbar,
        notifications,
        search,
        messages,
        app
    },
    strict: debug
    // plugins: debug ? [createPersistedState()] : [createPersistedState()]
})
